/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonContingentInfo,
    JsonContingentInfoFromJSON,
    JsonContingentInfoFromJSONTyped,
    JsonContingentInfoToJSON,
} from './JsonContingentInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonContingentInfo
 */
export interface ApiResultOfListOfJsonContingentInfo {
    /**
     * 
     * @type {Array<JsonContingentInfo>}
     * @memberof ApiResultOfListOfJsonContingentInfo
     */
    data?: Array<JsonContingentInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonContingentInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonContingentInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonContingentInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonContingentInfo
     */
    result?: ApiResultOfListOfJsonContingentInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonContingentInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonContingentInfoFromJSON(json: any): ApiResultOfListOfJsonContingentInfo {
    return ApiResultOfListOfJsonContingentInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonContingentInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonContingentInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonContingentInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonContingentInfoToJSON(value?: ApiResultOfListOfJsonContingentInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonContingentInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

